import React from 'react'
import { Helmet as Hm, HelmetProvider, HelmetData } from 'react-helmet-async';

const helmetData = new HelmetData({});
const Helmet = (props) => <Hm helmetData={helmetData} {...props} />

export {
    Helmet,
    HelmetData,
    HelmetProvider
}